import React from 'react'
import { Toaster } from 'react-hot-toast'
import { useReveal } from '@/hooks/useReveal'
import { SiteEditProvider } from '@/contexts/SiteEditContext'
import LiveEditToolbar from '@/components/editable/LiveEditToolbar'
import Nav from '@/components/Nav'
import Hero from '@/components/Hero'
import Vision from '@/components/Vision'
import Piliers from '@/components/Piliers'
import Poles from '@/components/Poles'
import Publics from '@/components/Publics'
import Conteneur from '@/components/Conteneur'
import Manifeste from '@/components/Manifeste'
import Partenaires from '@/components/Partenaires'
import Publications from '@/components/Publications'
import Contact from '@/components/Contact'
import Footer from '@/components/Footer'

const Home: React.FC = () => {
  useReveal()

  return (
    <SiteEditProvider>
      <div className="min-h-screen bg-[#0E1B2C] text-[#E8DCC4]">
        <Nav />
        <main>
          <Hero />
          <Vision />
          <Piliers />
          <Poles />
          <Publics />
          <Conteneur />
          <Manifeste />
          <Publications />
          <Partenaires />
          <Contact />
        </main>
        <Footer />
        <LiveEditToolbar />
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: '#14253B',
              color: '#E8DCC4',
              border: '1px solid rgba(232,220,196,0.15)',
              fontSize: '13px',
              letterSpacing: '0.04em',
            },
          }}
        />
      </div>
    </SiteEditProvider>
  )
}

export default Home
